import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateToSecondsLeft'
})
export class DateToSecondsLeftPipe implements PipeTransform {
  transform(value: string | number | Date): number {
    if (!value) return 0;
    const now = new Date().getTime();
    const target = new Date(value).getTime();
    const diff = Math.floor((target - now) / 1000);
    return diff > 0 ? diff : 0;
  }
}